import { createFragment } from "../utilities/elements";
import { defineElement } from "./registry";
import { DickTokStandaloneComponent } from "./StandaloneComponent";

export class DickTokMenuDivider extends DickTokStandaloneComponent {
  static template = createFragment`
      <div class="dt-menudivider__line"></div>`;
}

defineElement("dt-menudivider", DickTokMenuDivider);
